import {
  Component,
  Input,
  HostBinding
} from '@angular/core';

import { IconType } from './icon-types';
import { iconDefs } from './icon-defs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'suka-icon',
  template: `
    <span [innerHTML]="content"></span>
  `
})
export class Icon {
  // tslint:disable-next-line: variable-name
  protected _icon: IconType;
  content: SafeHtml;

  @HostBinding('class.suka-icon') baseClass = true;

  /**
   * Label for accesibility applications
   */
  @HostBinding('attr.aria-label') @Input() accessibilityLabel: string;

  /**
   * Sets the icon.
   */
  @Input()
  set icon(value: IconType) {
    this._icon = value;
    this.getIconDef();
  }

  get icon(): IconType {
    return this._icon;
  }

  constructor(private sanitizer: DomSanitizer) {}

  private getIconDef(): void {
    const iconDefinition = iconDefs.filter(iconDef => iconDef.name === this._icon)[0];
    if (!iconDefinition) {
      throw new Error(`Cant find '${this._icon}' icon.`);
    }
    this.content = this.sanitizer.bypassSecurityTrustHtml(iconDefinition.template);
  }
}
